<template>
  <div class="productApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading"    @resize="handleResize">
    <div class="content">
      <!--<div class="search">
        <div class="left" @click="$router.push('citys')">
          <span>当前位置</span>
          <font>{{cityData.length <=0 ? '定位中...' : cityData.cityName}}</font>
        </div>
        <div class="right">
          <input type="text" placeholder="按商家名称搜索" v-model="keywork" @input="search"/>
          <i class="el-icon-search"></i>
        </div>
      </div>
      <div style="height:60px"></div>-->
      <div class="navMall">
        <div :style="'width:'+((setMallCate.length - 7) * 85)+'px;height:48px;'">
          <a :class="cate_id == 0 ? 'curt' : ''" @click="clickMallCate(0)">全部</a>
          <a @click="clickMallCate(item.id)" v-for="(item,i) in setMallCate" :class="cate_id == item.id ? 'curt' : ''" v-if="item.types == 1">{{item.title}}</a>
        </div>
      </div>
      <div style="height:59px"></div>
      <div class="merchants" v-for="(item,i) in (keywork === '' ? business : searchArr)" @click="toPush(item.id,'detail')">
        <div class="brand">
          <el-image style="width: 90px; height: 70px" :src="baseUrl+item.logo" fit="cover"></el-image>
          <span>品牌</span>
        </div>
        <div class="title">
          <h3>{{item.title}}</h3>
          <div class="timer">
            <span>营业时间:{{item.business}}</span>
          </div>
          <div class="star"><img src="~assets/images/starO.png" />{{item.star}}
            <span>月售{{item.sale}}</span>
            <font>免费配送</font>
            <!--<font>距离{{item.distance}}KM</font>-->
          </div>
        </div>
        <div style="clear:both"></div>
        <dl v-if="item.names.length > 0">
          <dt>热销商品 <span>5折起</span><span>配送0元起</span><span>会员每日领优惠价</span></dt>
          <dd v-for="(vo,i) in item.names">
            <div class="proImg" :style="'background:url('+baseUrl+vo[3]+') no-repeat left center;background-size:100%'"></div>
            <div class="hotPro">
            <p>{{vo[0]}}</p>
            <div class="price">
              <span><i>￥</i>{{vo[2]}}</span>
              <font>￥{{parseInt(vo[1])}}</font>
            </div>
            </div>
          </dd>
        </dl>
      </div>

      <div class="none" v-if="((keywork === '' ? business : searchArr).length) <= 0 && cityData.length != 0">
        <p>您所在的<font>{{cityData.length <=0 ? '定位中...' : cityData.cityName}}</font>地区，暂无数据...</p>
        <!--<a @click="$router.push('citys')">切换地区</a>-->
      </div>
    </div>

    <div :style="bool == 1 ? 'height:85px' :'height:65px'"></div>
    <footComponent :idx='3' :dx='bool'></footComponent>
  </div>
</template>

<script>
  import $ from 'jquery'
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        active:1,
        page:1,
        business:[],
        isIphone:false,
        keywork:'',
        arr:[],
        searchArr:[],
        cityData:[],
        bool:0,
        setMallCate:[],
        cate_id:0
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        WeixinJSBridge.call('hideToolbar');
        WeixinJSBridge.call('hideOptionMenu');
      });
      window.removeEventListener("resize", this.handleResize);
    },
    created(){
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var id = this.$route.query.id == undefined ? 0 : this.$route.query.id;
          var url = encodeURIComponent('http://user.4008005216.com/main/product'+(id > 0 ?('?id='+id) : ''));
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
        }
      }else{
        this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
      }
    },
    mounted() {
      this.beforeMount();
      window.addEventListener("resize", this.handleResize);
      
      var id = this.$route.query.id == undefined ? 0 : this.$route.query.id;
      this.cate_id = id;
      if(localStorage.getItem('cCode') == null){
        this.getQquey();
      }else{
        var cCode = JSON.parse(localStorage.getItem('cCode'));
        if(cCode.expires <= Date.parse(new Date())){
          localStorage.removeItem('cCode');
          this.getQquey();
        }else{
          this.cityData = cCode;
          this.getBusiness(id)
          this.getMallCate();
        }
      }
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
        this.bool = (h >= 800 && this.isPhone() ? 1 : 0);
      },
      handleResize:function(e){
        if(this.curHeight < e.currentTarget.innerHeight && this.isPhone()){
          this.bool = 1;
        }else {
          if(this.curHeight >= 800 && this.curHeight == e.currentTarget.innerHeight && this.isPhone()){
            this.bool = 1;
          }else{
            this.bool = 0;
          }
        }
      },
      isPhone:function(){
        if (typeof window !== 'undefined' && window) {
            return /iphone/gi.test(window.navigator.userAgent) && window.screen.height >= 812;
        }
        return false;
      },
      toggle(index){
        this.active=index;
        this.getBusiness()
      },
      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },

      getQquey:function(){
        var that = this;

        var data = {cityCode: "450100", cityName: "南宁市", expires: 1919872956000,latitude:22.78658,longitude:108.49693,key:0};
        localStorage.setItem('cCode', JSON.stringify(data));
        that.cityData = data;
        that.getBusiness(that.cate_id);
        that.getMallCate();
        return false;
        
        let hashurl= window.location.href.split('#')[0];
        this.axios({
          'url': 'http://user.4008005216.com/wx/index.php',
          'method': 'post',
          params:{
            url:hashurl
          }
        }).then(function(response){
          var res = response.data;
          wx.config({
            debug: false,
            appId: res.appId,
            timestamp: res.timestamp,
            nonceStr: res.nonceStr,
            signature: res.signature,
            jsApiList: [
              'getLocation',
              'openLocation'
            ]
          });
          wx.ready(function() {
            wx.getLocation({
              type: 'wgs84',
              success: function (res) {
                $.ajax({
                  type:'post',
                  url:that.$host+'home/movies/getAddressInfo',
                  data:{
                    latitude:res.latitude,
                    longitude:res.longitude,
                  },
                  dataType:'json',
                  success:function(data){
                    var expires = Date.parse(new Date()) / 1000;
                    expires = (expires + 1800) * 1000;
                    var data = {
                      cityCode:data.data.city_code,
                      cityName:data.data.city,
                      expires:expires,
                      latitude:res.latitude,
                      longitude:res.longitude,
                      key:0
                    };
                    localStorage.setItem('cCode', JSON.stringify(data));
                    that.cityData = data;
                    that.getBusiness(that.cate_id);
                    that.getMallCate();
                  }
                })
              }
            });
          });

        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false;
        });
      },

      search:function(event){
        if(this.keywork === '') return;
        var value = this.keywork;
        var res = this.arr.filter(function(item){
          return item.title.indexOf(value) > -1
        })
        this.searchArr = res;
      },
      getMallCate:function(){
        var that = this;
        $.ajax({
          type:'post',
          url:that.$host+'home/index/mallCate',
          dataType:'json',
          success:function(data){
            that.setMallCate = data.data
          }
        })
      },
      clickMallCate:function(inx){
        this.cate_id = inx;
        this.getBusiness(inx)
      },

      getBusiness:function(cate_id){
        var that = this;
        that.fullscreenLoading = true
        $.ajax({
          type:'post',
          url:that.$host+'home/product/getMallBusiness',
          data:{
            latitude:that.cityData.latitude,
            longitude:that.cityData.longitude,
            keywords:(that.cityData.key == 1 ? that.cityData.cityName : ''),
            cid:cate_id
          },
          dataType:'json',
          success:function(data){
            that.business = data.data
            that.arr = data.data
            that.fullscreenLoading = false
          }
        })
      },

    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .productApp{
    max-width:640px;
    background:#ececec;
    margin:0 auto;
  }
  .productApp .content{
    width:100%
  }
  .productApp .content .search{
    position:fixed;
    width:100%;
    left:0;
    background:#ececec;
    height:55px;
    top:0;
    z-index:99
  }


  .productApp .content .search .left{
    float:left;
    height:55px;
    width:33%;
    margin-left:3%;
    position: relative;
  }
  .productApp .content .search .left span{
    width:40px;
    float:left;
    font-size:15px;
    color:#000;
    line-height:18px;
    position: relative;
    top:50%;
    transform: translateY(-50%);
  }
  .productApp .content .search .left span:after{
    position:absolute;
    content:'';
    width:3px;
    height:3px;
    background:#000;
    border-radius:10px;
    right:0
  }
  .productApp .content .search .left font{
    width:calc(100% - 47px);
    float:left;
    font-size:15px;
    line-height:18px;
    margin-left:7px;
    color:#666;
    position: relative;
    top:50%;
    transform: translateY(-50%);
  }
  .productApp .content .search .right{
    float:right;
    width:57%;
    height:55px;
    margin-right:3%;
    position: relative;
  }
  .productApp .content .search input{
    height:40px;
    width:calc(100% - 40px);
    outline:none;
    border:none;
    border-radius:40px;
    margin-top:7.5px;
    padding:0 10px 0 30px;
    font-size:15px
  }
  .productApp .content .search .right i{
    position:absolute;
    top:50%;
    transform: translateY(-50%);
    left:10px;
    color:#555;
    font-size:16px
  }
  .productApp .merchants{
    background:#fff;
    width:96%;
    display:block;
    margin:0 auto;
    margin-bottom:15px;
    padding-bottom:15px;
    border-radius: 6px;
  }
  .productApp .merchants:after,.productApp .merchants dl dd:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }

  .productApp .merchants .brand{
    float:left;
    width:25%;
    margin:15px 10px 0px 15px;
    position:relative;
  }
  .productApp .merchants .brand img{
    display:block;
    width:100%;
    border-radius: 5px;
  }
  .productApp .merchants .brand span{
    position:absolute;
    top:0;
    left:0;
    font-size:12px;
    background:rgba(0,0,0,0.3);
    color:#fff;
    border-radius: 5px 0 0 0;
    padding:2px 5px
  }
  .productApp .merchants .title{
    float:left;
    width:65%;
    margin-top:14px;
  }
  .productApp .merchants .title h3{
    font-size:15px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    color:#000;
  }
  .productApp .merchants .title .timer{
    display:inline-block;
    padding:4px 0 2px 0
  }
  .productApp .merchants .title .timer span{
    float:left;
    font-size:14px;
    color:#666;
  }
  .productApp .merchants .title .star{
    font-size:14px;
    color:rgb(255,102,0);
    vertical-align: top;
    font-weight:600;
  }
  .productApp .merchants .title .star img{
    width:12px;
    margin-right:3px;
  }
  .productApp .merchants .title .star span{
    color:#666;
    font-weight:500;
    font-size:12px;
    padding-left:8px
  }
  .productApp .merchants .title .star font{
    font-weight:500;
    font-size:12px;
    color:#666;
    padding-left:15px
  }


  .productApp .merchants dl{
    margin: 0 auto;
    width:92%;
  }
  .productApp .merchants dl dt{
    font-size:14px;
    padding:10px 0;
    font-weight:bold
  }
  .productApp .merchants dl dt span{
    font-weight:normal;
    font-size:12px;
    padding-left:10px;
    color:#555
  }
  .productApp .merchants dl dd{
    margin-bottom:10px;
  }
  .productApp .merchants dl dd .proImg{
    width:60px;
    height:60px;
    border-radius: 5px;
    float:left
  }
  .productApp .merchants dl dd .hotPro{
    float:left;
    width:75%;
    margin-left:3%;
    border-bottom:1px solid #f5f5f5;
  }
  .productApp .merchants dl dd p{
    font-size:14px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    color:#000;
    display:block;
    width:100%;
    padding:5px 0
  }
  .productApp .merchants dl dd .price{
    padding:2px 0 6px 0
  }
  .productApp .merchants dl dd .price span{
    color: #FF1E00;
    font-size:14px;
    font-weight:600;
    padding-right:5px
  }
  .productApp .merchants dl dd .price i{
    font-weigth:normal;
    font-size:10px;
    font-style: normal;
  }
  .productApp .merchants dl dd .price font{
    font-size:10px;
    text-decoration: line-through;
    color:#999
  }
  
  .productApp .none{
    width:80%;
    margin:0 auto;
    padding-top:50%
  }
  .productApp .none p{
    color:#333;
    font-size:15px;
    width:100%;
    text-align:center;
    margin-bottom:30px
  }
  .productApp .none p font{
    color:#e45442;
    font-weight:bold;
    padding:0 2px
  }
  .productApp .none a{
    display:block;
    background: #0059D6;
    height: 45px;
    border-radius: 8px;
    width:140px;
    text-align:center;
    line-height: 45px;
    color:#fff;
    margin:0 auto;
  }

  .sihanFoot .footer{
    padding-bottom:32px
  }


  .productApp .navMall{
    height:48px;
    background:#fff;
    border-bottom:1px solid #ececec;
    width:100%;
    top:0;
    left:0;
    position:fixed;
    z-index:99;
    overflow-x: auto;
    scrollbar-width: none;
  }
  .productApp .navMall a{
    float:left;
    height:48px;
    line-height:48px;
    font-size:14px;
    padding-left:15px;
    color:#333
  }
  .productApp .navMall a.curt{
    color:#FF1E00;
    font-weight:bold
  }
</style>